// src/data/careersData.js
// Static fallback jobs shown when Firestore is empty or unreachable
export const FALLBACK_JOBS = [
  {
    id: 'junior-qa-engineer',
    title: 'Junior QA Engineer',
    type: 'Full time',
    level: 'Mid level',
    department: 'Engineering',
    deadline: '5th May, 2026',
    desc: 'Join our QA team to ensure quality across government and enterprise software delivery pipelines.',
    description: 'Join our QA team to ensure quality across government and enterprise software delivery pipelines. You will work closely with development teams to design test strategies, automate test cases, and maintain quality standards across complex delivery environments.',
    requirements: 'Experience with manual and automated testing\nFamiliarity with test frameworks (Selenium, Cypress, or similar)\nStrong attention to detail and analytical skills\nExperience in Agile/Scrum environments\nGood communication and documentation skills',
    tags: 'QA, Testing, Automation, Agile',
  },
  {
    id: 'ui-ux-designer',
    title: 'UI/UX Designer',
    type: 'Contract',
    level: 'Senior level',
    department: 'Design',
    deadline: '5th May, 2026',
    desc: 'Design user-centered interfaces for complex government and enterprise technology systems.',
    description: 'Design user-centered interfaces for complex government and enterprise technology systems. You will lead design efforts from research and wireframing through to high-fidelity prototypes and design system maintenance.',
    requirements: 'Strong portfolio demonstrating UX process and UI craft\nProficiency in Figma or similar design tools\nExperience with design systems and component libraries\nAbility to work with stakeholders to translate requirements into intuitive designs\nFamiliarity with accessibility standards (WCAG)',
    tags: 'UI, UX, Figma, Design Systems, Accessibility',
  },
  {
    id: 'automation-engineer',
    title: 'Automation Engineer',
    type: 'Full time',
    level: 'Mid level',
    department: 'Engineering',
    deadline: '5th May, 2026',
    desc: 'Build and maintain automation frameworks that power our managed services delivery model.',
    description: 'Build and maintain automation frameworks that power our managed services delivery model. You will design, develop, and maintain scalable automation solutions that reduce manual effort and improve delivery consistency across our service lines.',
    requirements: 'Hands-on experience with automation frameworks and scripting (Python, Bash, or similar)\nExperience with CI/CD pipelines (Jenkins, GitHub Actions, or similar)\nKnowledge of cloud platforms (AWS, Azure, or GCP)\nAbility to document automation processes clearly\nExperience in government or regulated environments is a plus',
    tags: 'Automation, Python, CI/CD, Cloud, DevOps',
  },
];